import Card from "./resources/card";
import './App.css';
import Rodape from "./resources/rodape";

function App () {

    return (
        <main className="App">
            <Card/>
            <Rodape/>
        </main>
    );
}

export default App;